import { render, staticRenderFns } from "./CardSimilarityAccount.vue?vue&type=template&id=36bf2e6b&scoped=true&"
import script from "./CardSimilarityAccount.vue?vue&type=script&lang=js&"
export * from "./CardSimilarityAccount.vue?vue&type=script&lang=js&"
import style0 from "./CardSimilarityAccount.vue?vue&type=style&index=0&id=36bf2e6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf2e6b",
  null
  
)

export default component.exports